import axios from "axios";
import { withSkipGlobalError } from "@/lib/http/skip-global-error";
import { editorHeaders } from "@/lib/sacred-library/sacred-library-api";
import { getApiBaseUrl } from "@/lib/api-base";

const API = getApiBaseUrl();

function enc(id) {
  return encodeURIComponent(id);
}

export async function fetchTattvaIndex() {
  const res = await axios.get(`${API}/tattva`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data?.nodes ?? [];
}

export async function fetchTattvaNode(id) {
  const res = await axios.get(`${API}/tattva/${enc(id)}`, withSkipGlobalError({ headers: editorHeaders() }));
  return {
    node: res.data?.node,
    draft: res.data?.draft,
    source: res.data?.source,
  };
}

export async function saveTattvaNode(id, node, { draftOnly = true, publish = false } = {}) {
  const res = await axios.put(
    `${API}/tattva/${enc(id)}`,
    { node, draft_only: draftOnly, publish },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function submitTattvaNode(id, node) {
  const res = await axios.post(
    `${API}/tattva/${enc(id)}/submit`,
    { node },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function publishTattvaNode(id, node) {
  const res = await axios.post(
    `${API}/tattva/${enc(id)}/publish`,
    { node },
    withSkipGlobalError({ headers: editorHeaders() })
  );
  return res.data;
}

export async function fetchTattvaRelated(id) {
  const res = await axios.get(`${API}/tattva/related/${enc(id)}`, withSkipGlobalError());
  return res.data;
}

/** Admin-only graph integrity report */
export async function fetchTattvaDebug() {
  const res = await axios.get(`${API}/tattva/debug`, withSkipGlobalError({ headers: editorHeaders() }));
  return res.data;
}

/** Library topic key e.g. deity:shiva */
export function libraryGraphKey(type, id) {
  return `${type}:${id}`;
}
